import { useState } from "react";
import { AccordionItem } from "./AccordionItem";
import type { AccordionItemId, AccordionItemType } from "./AccordionItem";

export const Accordion = ({
  items,
  initialOpenIds,
}: {
  items: Omit<AccordionItemType, "isOpen" | "onToggle">[];
  initialOpenIds?: AccordionItemId[];
}) => {
  const [openIds, setOpenIds] = useState<AccordionItemId[]>(
    initialOpenIds || [],
  );

  function handleToggle(id: AccordionItemId) {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  }

  return (
    <div className="w-full">
      {items.map((item) => (
        <AccordionItem
          key={item.id}
          id={item.id}
          title={item.title}
          closedIcon={item.closedIcon}
          isOpen={openIds.includes(item.id)}
          onToggle={handleToggle}
        >
          {item.children}
        </AccordionItem>
      ))}
    </div>
  );
};
